/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GoogleReviewSyncStateView = {
    /**
     * idle | in_progress | needs_reconnect
     */
    syncStatus?: GoogleReviewSyncStateView.syncStatus;
    /**
     * ISO timestamp of the last successful sync; null if never synced
     */
    lastSyncAt?: string | null;
    /**
     * ISO timestamp before which a new sync is refused; null means eligible now
     */
    nextSyncAvailableAt?: string | null;
    /**
     * Error code of the last failure, or null
     */
    lastError?: string | null;
    /**
     * Consecutive failed/unfinished attempts; drives the backoff
     */
    consecutiveFailures?: number;
};
export namespace GoogleReviewSyncStateView {
    /**
     * idle | in_progress | needs_reconnect
     */
    export enum syncStatus {
        IDLE = 'idle',
        IN_PROGRESS = 'in_progress',
        NEEDS_RECONNECT = 'needs_reconnect',
    }
}

